export default class ProductUpdate {
	id: string;

	packageSizeForSingleUnit: number | null;

	priceTypeForCalculation: string | null;

	selected: boolean;

	constructor(
		id: string,
		packageSizeForSingleUnit: number | null,
		priceTypeForCalculation: string | null,
		selected: boolean
	) {
		this.id = id;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.priceTypeForCalculation = priceTypeForCalculation;
		this.selected = selected;
	}
}
